<div class="container">

  <app-header-dialog [iconName]="'settings_remote'">
    Push
  </app-header-dialog>

  <mat-tab-group>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>settings_remote</mat-icon>
        <div>Push</div>
      </ng-template>

      <div class='tab-content'>
        <form class="form" name="pushForm" [formGroup]='pushForm' autocomplete="off">


          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Título</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="pushForm.controls.title"
              autocomplete="off">
            <mat-error *ngIf="pushForm.controls.title.hasError('required')">
              Informe um Título
            </mat-error>
          </mat-form-field>


          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Texto</mat-label>
            <textarea style='height:120px;' matInput [errorStateMatcher]="matcher"
              [formControl]="pushForm.controls.text" autocomplete="off">
                            </textarea>

            <mat-error *ngIf="pushForm.controls.text.hasError('required')">
              O texto é obrigatório
            </mat-error>
          </mat-form-field>

          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Link</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="pushForm.controls.url"
              autocomplete="off">
            <mat-error *ngIf="pushForm.controls.url.hasError('required')">
              A URL é obrigatória
            </mat-error>
          </mat-form-field>

          <div style='margin-top:20px;'>
            <div>Agendamento</div>
            <mat-form-field class="date-width" appearance="outline">
              <mat-label>Data</mat-label>
              <input matInput [matDatepicker]="picker" [errorStateMatcher]="matcher"
                [formControl]="pushForm.controls.date_to_send">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error *ngIf="pushForm.controls.date_to_send.hasError('required')">
                Informe uma data para o envio
              </mat-error>
            </mat-form-field>

            <mat-form-field class="date-width" appearance="outline">
              <mat-label>Hora (hh:mm)</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="pushForm.controls.time_to_send"
                autocomplete="off">
              <mat-error *ngIf="pushForm.controls.time_to_send.hasError('required')">
                Informe uma hora para o envio
              </mat-error>
            </mat-form-field>

            <mat-checkbox color='primary' [formControl]="pushForm.controls.sent">
              Enviado
            </mat-checkbox>

          </div>

        </form>
      </div>

    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>group</mat-icon>
        <div>Destinatários</div>
      </ng-template>

      <div class='tab-content'>

        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Para quem enviar</mat-label>
          <mat-select [errorStateMatcher]="matcher" [formControl]="pushForm.controls.push_type"
            (ngModelChange)='on_push_type_changed($event)'>
            <mat-option *ngFor="let type of push_types" [value]="type.value">
              {{ type.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="pushForm.controls.push_type.hasError('required')">
            O tipo é obrigatório
          </mat-error>
        </mat-form-field>

        <div *ngIf='flag_todos' style='background-color: whitesmoke; padding:20px 10px 20px 10px; margin-top:10px;'>
          <span>Será enviado para todos os usuários com o app instalado</span>
        </div>

        <div *ngIf='flag_evento'>
          <mat-form-field class='full-width'  appearance="outline">
            <mat-select placeholder='Selecione um Evento' [formControl]="pushForm.controls.event_id">
              <mat-option *ngFor="let event of _eventService.arrayAllEvents" [value]="event.id">
                {{ event.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div *ngIf='flag_lista' style='background-color: whitesmoke; height:360px; margin-top:10px;'>

          <button mat-raised-button (click)='openMembersDialog()'>
            <mat-icon class='icon-add'>add_circle_outline</mat-icon>
          </button>

          <mat-table [dataSource]="targetListDataSource" matSort matSortActive="name"
            style='height:320px; overflow:auto; margin: 0;'>

            <ng-container matColumnDef="icon">
              <mat-header-cell *matHeaderCellDef> </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <mat-icon style='font-size:1.4em; color:rgba(0,0,0,.7);'>list</mat-icon>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.name }} </mat-cell>
            </ng-container>


            <ng-container matColumnDef="delete">
              <mat-header-cell *matHeaderCellDef> </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button (click)='remove_to_list(element)' style='background-color: whitesmoke;'>
                  <mat-icon style='font-size:1.5em; color:rgba(247, 10, 10, 0.7)'>delete_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedListColumns"></mat-header-row>

            <mat-row *matRowDef="let row; columns: displayedListColumns;">
            </mat-row>

          </mat-table>
        </div>

      </div>


    </mat-tab>

  </mat-tab-group>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

    <button mat-raised-button (click)='insert()' [disabled]="pushForm.invalid" *ngIf="!isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
    <button mat-raised-button (click)='update()' [disabled]="pushForm.invalid" *ngIf="isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

  </div>

</div>